/* eslint-disable @typescript-eslint/no-extraneous-class */
import type { Form } from '../../types/analytics';

export class FormBuilder {
  static buildGenericForm(contactForm: any, formName?: string): Form {
    return {
      ...contactForm,
      formName: formName ?? 'Generic Lead',
      formType: 'lead',
      formData: { ...contactForm.formData },
    } as Form;
  }

  static buildVTPForm(contactForm: any, vehicle: any): Form {
    return {
      ...contactForm,
      formName: 'VTP Lead',
      formType: 'lead',
      formData: {
        ...contactForm.formData,
        preferredDealer: vehicle?.dealer?.id,
        modelOfInterest: { modelFamily: vehicle?.titleText },
      },
    } as Form;
  }

  static buildNGCorMLPForm(contactForm: any, vehicle: any, leadSource: string): Form {
    return {
      ...contactForm,
      formName: leadSource === 'mlp' ? 'MLP Lead' : 'Configurator Lead',
      formType: 'lead',
      formData: {
        ...contactForm.formData,
        modelOfInterest: { modelFamily: vehicle?.titleText },
      },
    } as Form;
  }

  static buildPromotionsForm(contactForm: any, dealerId: string, modelName: string): Form {
    return {
      ...contactForm,
      formName: 'Promotions Lead',
      formType: 'lead',
      formData: {
        ...contactForm.formData,
        preferredDealer: dealerId,
        modelOfInterest: { modelFamily: modelName },
      },
    } as Form;
  }

  static addLeadId(form: any, leadId: string): any {
    return { ...form, leadId };
  }
}
